<template>
  <!-- Login Section 01 -->
  <div class="login-section">
    <section class>
      <div class="container_1">
        <div class="row justify-content-center">
          <div class="col-lg-12 order-lg-2">
            <div class="hero-image">
              <img src="/assets/exported/login.jpg" alt />
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container login_hero">
      <!-- <div class="login_loading" v-if="OfflineisLoading">
           <div class="spinnerdes">
            <div class="dot1"></div>
            <div class="dot2"></div>
          </div>
      </div>-->
      <h2>{{ $root.login_head.login_text }}</h2>
      <div>
        <ul>
          <li class="error">{{ error[0] }}</li>
        </ul>
      </div>
      <form @submit.prevent method="post">
        <div class="container">
          <label for="uname">
            <b>{{ $root.login_email.login_e_text }}</b>
          </label>
          <input
            class="error-fleid"
            type="text"
            v-model="login.email"
            @input="emailError = false"
            placeholder
            name="email"
          />
          <!-- Error masaage -->
          <div
            class="error_body"
            v-if="typeof errormessage.errors != 'undefined' && emailError == true"
          >
            <ul v-if="typeof errormessage.errors.email != 'undefined'">
              <li
                v-for="email_id in errormessage.errors.email"
                :key="email_id.id"
                class="error_data"
              >{{email_id}}</li>
            </ul>
          </div>
          <!-- Error masaage end-->
          <label for="psw">
            <b>{{ $root.login_password.login_p_text }}</b>
          </label>
          <input
            type="password"
            v-model="login.passwords"
            @input="passwordError = false"
            id="myInput"
          />
          <span class="show_eye" @click="myFunction(),toggledropdown">
            <span>
              <i class="fa fa-eye" aria-hidden="true"></i>
            </span>
            <span>
              <!-- <i class="fa fa-eye-slash" aria-hidden="true"></i> -->
            </span>
          </span>
          <!-- Error masaage -->
          <div
            class="error_body"
            v-if="typeof errormessage.errors != 'undefined' && passwordError == true"
          >
            <ul v-if="typeof errormessage.errors.password != 'undefined'">
              <li
                v-for="password_id in errormessage.errors.password"
                :key="password_id.id"
                class="error_data"
              >{{password_id}}</li>
            </ul>
          </div>
          <!-- Error masaage end-->
          <div class="log_button">
            <button @click="loginsub" type="submit">
              {{ $root.login_head.login_text }}
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </form>
      <div class="container">
        <!-- <button type="button" class="cancelbtn">Cancel</button>-->
        <span class="psw">
          <router-link to="/forget_password">{{ $root.login_forget.login_f_text }}</router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import axios from "axios";
export default {
  name: "",
  data() {
    return {
      login: {
        email: "",
        passwords: "",
      },
      error: [],
      errors: [],
      email: [],
      message: [],
      errormessage: [],
      emailError: false,
      passwordError: false,
      password: [],
    };
  },
  components: {},
  methods: {
    myFunction() {
      var x = document.getElementById("myInput");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    loginsub() {
      axios
        .post(
          this.$root.API_BASE_URL + "security-login",
          {
            email: this.login.email,
            password: this.login.passwords,
          },
          {
            headers: {
              // 'Authorization': 'bearer'+ token
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.status == true) {
            localStorage.setItem("profile", JSON.stringify(response.data));
            this.$root.user_profile = response.data;
            this.$root.logged_in = true;
            this.$router.push("/course_list");
            // Cache API calls to Local Storage
            this.$root.cacheAPI();
          } else {
            //this.error = response.data.message
            swal({
              text: "ইমেল বা পাসওয়ার্ড ভুল! আবার চেষ্টা করুন।",
              buttons: {
                confirm: { text: "ঠিক আছে" },
              },
            });
            // alert("Error: " + response.data.message);
            // console.log(response.data.message);
          }
        })
        .catch((error) => {
          //offline Status
          if (navigator.onLine) {
            // alert("online")
            //this.errors.push(error.response.data.errors.email[0]);
            //swal({
            // text:'ইমেইলটি সঠিক নয়! আবার চেষ্টা করুন।',
            // buttons: {
            //   confirm : {text:'ঠিক আছে'},
            //  },
            //});  this.errormessage = error.response.data;
            console.log("ERRRR:: ", error.response.data);
            this.errormessage = error.response.data;
            if (typeof this.errormessage.errors.email != "undefined") {
              this.emailError = true;
            }
            if (typeof this.errormessage.errors.password != "undefined") {
              this.passwordError = true;
            }
          } else {
            swal({
              text: "আপনার ইন্টারনেট কানেকশনটি একটিভেট করুন",
              buttons: {
                confirm: { text: "ঠিক আছে" },
              },
            });
            //this.connectionStatus = "Unable to connect to internet.";
          }
        });
    },
  },
};
</script>
<style scoped>
input[type="email"] {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
}
.error-fleid {
  transition: border-color 0.5s ease-out;
}

input:required:valid {
  border-color: green;
}
.error-fleid:required:focus:valid {
  background: url("/assets/exported/right.svg") no-repeat 98.3% 50%;
  background-size: 14px;
}
.error-fleid:invalid {
  background: url("/assets/exported/error.svg") no-repeat 98.1% 50%;
  background-size: 16px;
}
.login_loading {
  position: absolute;
  left: 0;
  top: auto;
  background: #fff;
  z-index: 1012;
  width: 100%;
  height: auto;
  text-align: center;
  justify-content: center;
  display: flex;
  right: 0;
  padding: 50px;
  opacity: 0.8;
}
.show_eye {
  position: absolute;
  padding: 24px 0px;
  margin-left: -30px;
  font-size: 16px;
  color: #005a06;
}
.error {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: red;
}

@media screen and (max-width: 1500px) {
  .error-fleid:required:focus:valid {
    background: url("/assets/exported/right.svg") no-repeat 97.5% 50%;
    background-size: 15px;
  }
  .error-fleid:invalid {
    background: url("/assets/exported/error.svg") no-repeat 97.2% 50%;
    background-size: 16px;
  }
}
@media screen and (max-width: 768px) {
  .error {
    font-size: 18px;
  }
  input[type="email"] {
    width: 100%;
    padding: 6px 20px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 6px;
  }
  .error-fleid:required:focus:valid {
    background: url("/assets/exported/right.svg") no-repeat 97.2% 50%;
    background-size: 12px;
  }
  .error-fleid:invalid {
    background: url("/assets/exported/error.svg") no-repeat 97.2% 50%;
    background-size: 14px;
  }
  .show_eye {
    position: absolute;
    padding: 19px 0px;
    margin-left: -28px;
    font-size: 15px;
    color: #005a06;
  }
}
@media screen and (max-width: 480px) {
  .error-fleid:required:focus:valid {
    background: url("/assets/exported/right.svg") no-repeat 96% 50%;
    background-size: 12px;
  }
  .error-fleid:invalid {
    background: url("/assets/exported/error.svg") no-repeat 96% 50%;
    background-size: 14px;
  }
}
</style>
